import { render, staticRenderFns } from "./Detailsvoyage.vue?vue&type=template&id=5e754e0a&scoped=true"
import script from "./Detailsvoyage.vue?vue&type=script&lang=js"
export * from "./Detailsvoyage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e754e0a",
  null
  
)

export default component.exports